import { useAuiState } from '@assistant-ui/react';

import { getModelSetLabel } from './model-set-metadata.js';

/** Marks the initial model and subsequent model changes in a conversation. */
export function ModelSetDivider() {
	const modelName = useAuiState((state) => getModelSetLabel(state.thread.messages, state.message.index));

	if (!modelName) {
		return null;
	}

	return (
		<div role='separator' aria-label={`Model set: ${modelName}`} className='mb-4 flex items-center gap-3 text-gray-a9'>
			<div aria-hidden className='h-px min-w-8 flex-1 bg-gray-6' />
			<span className='font-mono text-xs'>Model set: {modelName}</span>
			<div aria-hidden className='h-px min-w-8 flex-1 bg-gray-6' />
		</div>
	);
}
